import React, { useState, useEffect } from 'react';
import './icfes.css';
import ModalIcfes from './modalicfes/modalicfes';
import carga from '../../carga/carga';

function Icfes() {
  const [icfes, setIcfes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    descriptionp: '',
    categoria: '',
    codigo: '',
    pensum: '',
    materias_claves: [],
    perfil_egresado: '',
    campo_laboral: '',
    habilidades: [],
    cards: [],
    cardPrincipal: '',
  });
  const [inputValues, setInputValues] = useState({
    materias_claves: '',
    habilidades: '',
    cards: '',
  });
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    loadIcfes();
  }, []);

  const loadIcfes = async () => {
    try {
      setLoading(true);
      carga.mostrarCarga();
      await new Promise((resolve) => setTimeout(resolve, 100));
      setIcfes([]);
    } catch (error) {
      console.error('Error cargando ICFES:', error);
      alert('Error al cargar los registros de ICFES');
    } finally {
      setLoading(false);
      carga.ocultarCarga();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleArrayInputChange = (e) => {
    const { name, value } = e.target;
    setInputValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const addArrayItem = (field) => {
    const value = inputValues[field].trim();
    if (value) {
      const items = value.includes(',')
        ? value.split(',').map((item) => item.trim()).filter((item) => item !== '')
        : [value];

      setFormData((prev) => ({
        ...prev,
        [field]: [...prev[field], ...items],
      }));
      setInputValues((prev) => ({
        ...prev,
        [field]: '',
      }));
    }
  };

  const removeArrayItem = (field, index) => {
    setFormData((prev) => ({
      ...prev,
      [field]: prev[field].filter((_, i) => i !== index),
    }));
  };

  const moveArrayItem = (field, fromIndex, toIndex) => {
    setFormData((prev) => {
      const items = [...prev[field]];
      if (toIndex < 0 || toIndex >= items.length) return prev;
      const [item] = items.splice(fromIndex, 1);
      items.splice(toIndex, 0, item);
      return {
        ...prev,
        [field]: items,
      };
    });
  };

  const resetForm = () => {
    setFormData({
      nombre: '',
      descripcion: '',
      descriptionp: '',
      categoria: '',
      codigo: '',
      pensum: '',
      materias_claves: [],
      perfil_egresado: '',
      campo_laboral: '',
      habilidades: [],
      cards: [],
      cardPrincipal: '',
    });
    setInputValues({
      materias_claves: '',
      habilidades: '',
      cards: '',
    });
    setEditingId(null);
  };

  const openNewForm = () => {
    resetForm();
    setIsModalOpen(true);
  };

  const editIcfes = (item) => {
    setFormData({
      nombre: item.nombre || '',
      descripcion: item.descripcion || '',
      descriptionp: item.descriptionp || '',
      categoria: item.categoria || '',
      codigo: item.codigo || '',
      pensum: item.pensum || '',
      materias_claves: item.materias_claves || [],
      perfil_egresado: item.perfil_egresado || '',
      campo_laboral: item.campo_laboral || '',
      habilidades: item.habilidades || [],
      cards: item.cards || [],
      cardPrincipal: item.cardPrincipal || '',
    });
    setEditingId(item.id);
    setIsModalOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nombre || !formData.codigo) {
      alert('El nombre y código son requeridos');
      return;
    }

    try {
      setLoading(true);
      carga.mostrarCarga();

      if (editingId) {
        setIcfes((prev) => prev.map((item) => (item.id === editingId ? { ...item, ...formData } : item)));
      } else {
        setIcfes((prev) => [
          { ...formData, id: Date.now().toString() },
          ...prev,
        ]);
      }

      setIsModalOpen(false);
      resetForm();
      alert(editingId ? 'Registro de ICFES actualizado' : 'Registro de ICFES creado');
    } catch (error) {
      console.error('Error guardando ICFES:', error);
      alert('Error al guardar el registro de ICFES');
    } finally {
      setLoading(false);
      carga.ocultarCarga();
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm(`¿Deseas eliminar el registro de ICFES con id "${id}"?`)) {
      try {
        carga.mostrarCarga();
        setIcfes((prev) => prev.filter((item) => item.id !== id));
        alert('Registro eliminado');
      } catch (error) {
        console.error('Error eliminando registro de ICFES:', error);
        alert('Error al eliminar el registro de ICFES');
      } finally {
        carga.ocultarCarga();
      }
    }
  };

  const filteredIcfes = icfes.filter(
    (item) =>
      item.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.codigo.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="programas-container">
      <div className="programas-header">
        <h2>Gestión de ICFES</h2>
        <button className="btn-create" onClick={openNewForm}>
          + Nuevo Registro ICFES
        </button>
      </div>

      <div className="programas-search">
        <input
          type="text"
          placeholder="Buscar por nombre o código..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      {loading && !isModalOpen ? (
        <div className="loading-state">Cargando ICFES...</div>
      ) : filteredIcfes.length === 0 ? (
        <div className="empty-state">
          <p>No hay registros de ICFES</p>
        </div>
      ) : (
        <div className="programas-table-wrapper">
          <table className="programas-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Código</th>
                <th>Categoría</th>
                <th>Descripción</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filteredIcfes.map((item) => (
                <tr key={item.id}>
                  <td className="cell-name">{item.nombre}</td>
                  <td className="cell-code">{item.codigo}</td>
                  <td>{item.categoria}</td>
                  <td className="cell-description">
                    {item.descripcion.substring(0, 50)}...
                  </td>
                  <td className="cell-actions">
                    <button
                      className="btn-edit"
                      onClick={() => editIcfes(item)}
                      title="Editar"
                    >
                      ✏️
                    </button>
                    <button
                      className="btn-delete"
                      onClick={() => handleDelete(item.id)}
                      title="Eliminar"
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <ModalIcfes
        isOpen={isModalOpen}
        editingId={editingId}
        formData={formData}
        inputValues={inputValues}
        onInputChange={handleInputChange}
        onArrayInputChange={handleArrayInputChange}
        onAddArrayItem={addArrayItem}
        onRemoveArrayItem={removeArrayItem}
        onMoveArrayItem={moveArrayItem}
        onSubmit={handleSubmit}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
}

export default Icfes;
